angular.module('bmsApp.dashboard')
	.controller('DashboardLeagueTableCtrl', function ($scope, $rootScope, LeagueTableSvc, moment, ngTableParams, $localStorage) {

		var self = this;
		$scope.loading = true;

		angular.extend(self, {
			chartConfig: {
				chart: {
					type: 'line'
				},
				title: {
					text: ''
				},
				xAxis: {
					categories: [],
					crosshair: true
				},
				yAxis: {
					min: 0,
					labels: {
						formatter: function () {
							// return '£' + this.value.toFixed(0);
							return '£' + this.axis.defaultLabelFormatter.call(this);
							// return '£' + this.value.toFixed(0).replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1,");
						}
					},
					gridLineColor: '#eff1ef',
					gridLineWidth: 1,
					lineWidth: 1,
					plotLines: [
						{
							color: '#FF0000',
							width: 1,
							value: 0
						}
					],
					title: {
						text: 'Net Revenue (£)'
					},
					tickInterval: 1
				},
				tooltip: {
					headerFormat: '<span style="font-size:10px">{point.key}</span><table>',
					pointFormat: '<tr><td style="color:{series.color};padding:0">{series.name}: </td>' +
						'<td style="padding:0"><b>{point.y}</b></td></tr>',
					footerFormat: '</table>',
					shared: true,
					useHTML: true
				},
				plotOptions: {
					column: {
						pointPadding: 0.2,
						borderWidth: 0
					}
				},
				series: [],
				credits: {
					enabled: false
				}
			},
			ranges: [],
			handlers: {
				downloadPerformanceDataCSV: downloadPerformanceDataCSV,
				downloadLeagueTableDataCSV: downloadLeagueTableDataCSV
			}
		});

		var params = {
			page: 1, // show first page
			count: 10, // count per page
			format: 'json',
		};

		$scope.tableParams = new ngTableParams(params, {
			total: 0, // length of data
			counts: $scope.config.table.settings.counts, // available page counts
			getData: function ($defer, params) {
				$localStorage.employeeIndexParams = params.$params;
				loadLeagueData(params, $defer);
			}
		});

		for(var i=1;i<=12;i++){
			self.ranges.push(moment().subtract(i, 'months').format('MMM YY'));
		}

		loadPerformanceGraph();
		loadPerformanceData();

		function loadLeagueData(params, $defer) {
			$scope.updating = true;
			self.data = LeagueTableSvc.compare(params.$params).then(function (response) {
				$scope.updating = false;
				$defer.resolve(response.data.row_collection);
				params.total(response.data.total_count);
			});
		}

		function loadPerformanceGraph(){
			LeagueTableSvc.performanceGraph()
				.then((response) => {
					$scope.loading = false;
					self.chartConfig.xAxis.categories = response.data.categories;
					angular.forEach(response.data.series_collection, function (series) {
						self.chartConfig.series.push({
							name: series.name,
							data: series.data
						});
					});
				}, function (errors) {
					if (angular.isArray(errors)) {
						angular.forEach(errors, function (err) {
							notify({
								message: 'Performance Widget: ' + err,
								classes: 'error',
							});
						});
					}
				});
		}

		function downloadPerformanceDataCSV() {
			let params = {
				format: 'csv',
			};
			LeagueTableSvc.performanceData(params);
		}

		function downloadLeagueTableDataCSV() {
			let params = {
				format: 'csv',
			};
			LeagueTableSvc.compare(params);
		}


		function loadPerformanceData() {
			self.data = LeagueTableSvc.performanceData({format:'json'}).then(function (response) {
				self.performanceData = response.data.performance_data;
			});
		}
	});
